import actions from "src/actions";
import type { InstagramAccount } from "../types";

/**
 * Page-scoped Instagram actors for the advertiser identity picker: Meta merges
 * accounts on the selected Facebook page with the ad-account catalog.
 */
export async function fetchInstagramAccountsForAdvertiserPage(args: {
  ad_account_id: string;
  facebook_page_id: string;
}): Promise<InstagramAccount[]> {
  const pageId = args.facebook_page_id.trim();
  const adAccountId = args.ad_account_id.trim();
  if (!pageId || !adAccountId) {
    return [];
  }

  const rows = await actions.ADMIN.listInstagramAccounts({
    ad_account_id: adAccountId,
    facebook_page_id: pageId,
  });
  return (rows as InstagramAccount[]) ?? [];
}
